import { render } from "./bindServiceV2.vue?vue&type=template&id=b644a6c6&scoped=true"
import script from "./bindServiceV2.vue?vue&type=script&lang=js"
export * from "./bindServiceV2.vue?vue&type=script&lang=js"

import "./bindServiceV2.vue?vue&type=style&index=0&id=b644a6c6&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/staging-package-front-service/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b644a6c6"]])

export default __exports__